export enum NavigationWidgetTargets {
    PREVIOUS_SCENE = "previous",
    NEXT_SCENE = "next",
}

export {
    NavigationWidgetTargets  as default,
}



// WEBPACK FOOTER //
// ./src/editor/ui/editor/NavigationWidgetTargets.tsx